import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthServerProvider, IUser } from 'app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { faCoffee, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { DataSharingService } from 'app/layouts/homepage/services/data-sharing.service';

@Component({
    selector: 'jhi-change-pin',
    templateUrl: './change-pin.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class ChangePinComponent implements OnInit, OnDestroy {
    user: IUser;
    pinForm: FormGroup;
    submitted = false;
    errorCheck = false;
    showPin = false;
    appUrl = '';
    faCoffee = faCoffee;
    successMsg: string;
    faEyeSlash = faEyeSlash;
    faEye = faEye;
    errorMsg = '';
    loading: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private userService: UserService,
        private jwtService: AuthServerProvider,
        private router: Router,
        private dataSharingService: DataSharingService
    ) {
        this.loading = true;
        this.createForm();
        this.appUrl = this.route.snapshot.queryParamMap.get('appUrl');
    }

    ngOnInit() {
        this.jwtService
            .authorize()
            .toPromise()
            .then(res => {
                this.getInitData();
            })
            .catch(err => {});
    }

    private createForm() {
        this.pinForm = this.formBuilder.group({
            pin: ['', [Validators.required]]
        });
    }

    get f() {
        return this.pinForm.controls;
    }

    get fPin() {
        return this.pinForm.get('pin');
    }

    onSubmit() {
        this.errorCheck = true;
        // stop here if form is invalid
        if (this.pinForm.invalid) {
            return;
        }
        this.submitted = true;
        const outObj: number = this.fPin.value;
        this.userService
            .changePin(outObj)
            .toPromise()
            .then(res => {
                if (res && res.body && res.body.message) {
                    this.successMsg = res.body.message;
                } else {
                    this.successMsg = 'Operazione effettuata con successo';
                }
            })
            .catch(err => {
                if (err && err.error) {
                    this.errorMsg = err.error.message;
                }
            })
            .finally(() => {
                this.submitted = false;
            });
    }

    onReset() {
        this.submitted = false;
        this.fPin.reset();
        this.populateForm();
        this.pinForm.markAsPristine();
    }

    private getInitData() {
        this.userService
            .getLogged()
            .toPromise()
            .then(res => {
                this.user = res.body;
                this.populateForm();
            })
            .catch(err => {
                // console.log(err);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private populateForm() {
        this.pinForm.patchValue({
            pin: this.user.pin
        });
    }

    changeShowPin() {
        this.showPin = !this.showPin;
    }

    backToApp() {
        this.router.navigate(['/']);
    }

    ngOnDestroy() {
        this.jwtService.logout();
    }

    get isDesktop(): boolean {
        return this.dataSharingService.isDesktop();
    }
}
